import React from 'react';
import SvgIcon from '../SvgIcon';

/**
 * @ignore - internal component.
 */
function WatchLater(props) {
  return (
    <SvgIcon {...props}>
      <defs>
        <path id="a" d="M0 0h24v24H0z" />
      </defs>
      <clipPath>
        <use xlinkHref="#a" overflow="visible" />
      </clipPath>
      <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.2 3.2.8-1.3-4.5-2.7z" />
    </SvgIcon>
  );
}

export default React.memo(WatchLater);



// WEBPACK FOOTER //
// ./src/icons/internals/WatchLater.jsx